const GUEST = 1;
const GENERAL = 5;
const ADMIN = 9;
const PERMISSION = {
  ID_OPERATIONS_PERSONNEL: "ユーザIDオペレーション担当者",
  ADMINISTRATOR: "管理担当者",
  CHIEF_ADMINISTRATOR: "管理責任者",
  SYSTEM_ADMINISTRATOR: "システム管理者",
  MAINTENANCE_STAFF: "保守担当",
};
let access_rules = {
  // The "generic" is here for reference, but should not be used
  generic: { 
    // save: [GENERAL, ADMIN],
    // full: [
    //   PERMISSION.ID_OPERATIONS_PERSONNEL,
    //   PERMISSION.ADMINISTRATOR,
    //   PERMISSION.CHIEF_ADMINISTRATOR,
    //   PERMISSION.SYSTEM_ADMINISTRATOR,
    //   PERMISSION.MAINTENANCE_STAFF,
    // ],
    // browse: [
    //   PERMISSION.ID_OPERATIONS_PERSONNEL,
    //   PERMISSION.ADMINISTRATOR,
    //   PERMISSION.CHIEF_ADMINISTRATOR,
    //   PERMISSION.SYSTEM_ADMINISTRATOR,
    //   PERMISSION.MAINTENANCE_STAFF,
    // ],
    // add: [
    //   PERMISSION.ID_OPERATIONS_PERSONNEL,
    //   PERMISSION.ADMINISTRATOR,
    //   PERMISSION.CHIEF_ADMINISTRATOR,
    //   PERMISSION.SYSTEM_ADMINISTRATOR,
    //   PERMISSION.MAINTENANCE_STAFF,
    // ],
    // edit: [
    //   PERMISSION.ID_OPERATIONS_PERSONNEL,
    //   PERMISSION.ADMINISTRATOR,
    //   PERMISSION.CHIEF_ADMINISTRATOR,
    //   PERMISSION.SYSTEM_ADMINISTRATOR,
    //   PERMISSION.MAINTENANCE_STAFF,
    // ],
    // delete: [
    //   PERMISSION.ID_OPERATIONS_PERSONNEL,
    //   PERMISSION.ADMINISTRATOR,
    //   PERMISSION.CHIEF_ADMINISTRATOR,
    //   PERMISSION.SYSTEM_ADMINISTRATOR,
    //   PERMISSION.MAINTENANCE_STAFF,
    // ],
    // export: [
    //   PERMISSION.ID_OPERATIONS_PERSONNEL,
    //   PERMISSION.ADMINISTRATOR,
    //   PERMISSION.CHIEF_ADMINISTRATOR,
    //   PERMISSION.SYSTEM_ADMINISTRATOR,
    //   PERMISSION.MAINTENANCE_STAFF,
    // ],
  },
  device_embedded_information: {
    full: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  device_embedded_information_detail: {
    full: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  device_embedded_detail: {
    full: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  certificate_information: {
    browse: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    add: [
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF],
    edit: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    delete: [
      PERMISSION.SYSTEM_ADMINISTRATOR, 
      PERMISSION.MAINTENANCE_STAFF
    ],
    export: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  certificate_information_detail: {
    browse: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    add: [
      PERMISSION.SYSTEM_ADMINISTRATOR, 
      PERMISSION.MAINTENANCE_STAFF
    ],
    edit: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    delete: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    export: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  associated_device: {
    full: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },

  certificate_software: {
    browse: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    add: [
      PERMISSION.SYSTEM_ADMINISTRATOR, 
      PERMISSION.MAINTENANCE_STAFF
    ],
    edit: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    delete: [
      // PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    export: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  certificate: {
    browse: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    add: [
      PERMISSION.SYSTEM_ADMINISTRATOR, 
      PERMISSION.MAINTENANCE_STAFF
    ],
    edit: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    delete: [
      // PERMISSION.ADMINISTRATOR,
      // PERMISSION.CHIEF_ADMINISTRATOR,
      // PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    export: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },

  surplus_license: {
    browse: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    add: [
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF
    ],
    edit: [
      // Don't exist, but for consistency is a copy of add
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    delete: [
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF
    ],
    export: [
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF
    ],
  },
  surplus_license_detail: {
    browse: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    add: [
      // Don't exist, but for consistency is a copy of edit
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    edit: [
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF
    ],
    delete: [
      // Don't exist, but for consistency is a copy of edit
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    export: [
      // Don't exist, but for consistency is a copy of browse
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  surplus_license_allocation_request: {
    full: [
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF
    ],
  },
  approval_history: {
    full: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  inventory: {
    full: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  inventory_report: {
    full: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  inventory_report_check: {
    full: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  bulk_import: {
    full: [
      // PERMISSION.ADMINISTRATOR,
      // PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  bulk_import2: {
    full: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  master_user_password: {
    full: [
      PERMISSION.ID_OPERATIONS_PERSONNEL,
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  master_user: {
    browse: [
      PERMISSION.ID_OPERATIONS_PERSONNEL,
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    add: [
      PERMISSION.ID_OPERATIONS_PERSONNEL,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    edit: [
      PERMISSION.ID_OPERATIONS_PERSONNEL,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    delete: [
      PERMISSION.ID_OPERATIONS_PERSONNEL,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    export: [
      PERMISSION.ID_OPERATIONS_PERSONNEL,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  master_user_detail: {
    browse: [
      PERMISSION.ID_OPERATIONS_PERSONNEL,
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    add: [
      // Don't exist, but for consistency is a copy of edit
      PERMISSION.ID_OPERATIONS_PERSONNEL,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    edit: [
      PERMISSION.ID_OPERATIONS_PERSONNEL,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    delete: [
      PERMISSION.ID_OPERATIONS_PERSONNEL,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    export: [
      // Don't exist, but for consistency is a copy of browse
      PERMISSION.ID_OPERATIONS_PERSONNEL,
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  master: {
    full: [
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF
    ],
  },
  master_bel_mak_sys: {
    browse: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    add: [
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    edit: [
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    delete: [
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
    export: [
      PERMISSION.ADMINISTRATOR,
      PERMISSION.CHIEF_ADMINISTRATOR,
      PERMISSION.SYSTEM_ADMINISTRATOR,
      PERMISSION.MAINTENANCE_STAFF,
    ],
  },
  maintenance: {
    full: [PERMISSION.MAINTENANCE_STAFF],
  },
};

module.exports = access_rules;
// Try to delete the Don't exist items.



// WEBPACK FOOTER //
// ./src/rules/acl_rules.js